// Role-change dropdowns (Onboarding, Employee List edit form). Client is
// excluded — it's only ever chosen at creation, via ROLE_OPTIONS_INCLUDING_CLIENT.
export const ROLE_OPTIONS = [
  { label: 'Member', value: 'Member' },
  { label: 'Manager', value: 'Manager' },
  { label: 'Admin', value: 'Admin' },
];

// Add User's per-row picker. Selecting Client routes that row through the
// client-invite path instead of the employee-invite path at submit time.
export const ROLE_OPTIONS_INCLUDING_CLIENT = [
  ...ROLE_OPTIONS,
  { label: 'Client', value: 'Client' },
];

// Only a Super Admin can grant the Admin role — filters 'Admin' out of a role
// picker's options for anyone else, instead of hiding it at three separate
// call sites.
export function getAssignableRoleOptions(options, { isSuperAdmin }) {
  return isSuperAdmin ? options : options.filter((o) => o.value !== 'Admin');
}
